import type {
  ShipType,
  ShipTypeApi,
  ShipTypeFilters,
  ShipTypeFiltersUpdateApi,
  ShipTypes,
  ShipTypesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeShipType = (shipType: ShipTypeApi): ShipType => ({
  ...shipType,
  label: shipType.codeDesc,
});

export const normalizeShipTypes = (response: ShipTypesApi): ShipTypes => {
  const list = (response.items ?? []).map(normalizeShipType);
  return {
    list,
    map: list.reduce(
      (acc, shipType) => {
        acc[String(shipType.id)] = shipType;
        return acc;
      },
      {} as ShipTypes['map'],
    ),
  };
};

export const normalizeShipTypeFilters = (filters: Partial<ShipTypeFilters>): ShipTypeFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
